import React, { useState, useContext, useEffect,useRef, useMemo } from 'react';
import '../../../assets/css/chatEstilos.css'
import '../../../assets/css/views/recargas.css'

import { Modal } from '../../components/modal/Modal';

import { ModalRecarga } from '../../components/modal/ModalRecarga';
import { DatePickerABX } from '../../components/pickers/DatePicker';

import { BotonesEstado } from '../../components/buttons/BotonEstado';
import { notify, soloDecimal, formatState, primeraLetraMayuscula, obtenerHoraActual, formatDate } from '../../../utils/utils'
import { SocketContext } from '../../../context/provider/SocketProvider'
import { Tooltip } from '../../components/utils/Tooltip';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { useRecargas } from '../../../hooks/useRecargas';
import { useModal } from '../../../hooks/useModal';
import sonidoRecarga from '../../../assets/sound/sonidoRecarga.mp3'
import { useHistorialRecargas } from '../../../hooks/useHistorialRecargas';
import { useAmonestaciones } from '../../../hooks/useAmonestaciones';
import { SearchTable } from '../../components/utils/SearchTable';
import { UserContext } from '../../../context/provider/UserProvider';
import { useChatOnline } from '../../../hooks/useChatOnline';
import fotoChat from '../../../../src/assets/images/fotousuarioBeex.fw.png'
import fotobeexserver from '../../../../src/assets/images/fotousuarioBeexserver.fw.png'
import { soloNumero } from '../../../utils/utils';
import { useImagenaTexto } from '../../../hooks/useImagenaTexto';
import { useOperaciones } from '../../../hooks/useOperaciones';
import { useHistory } from "react-router-dom";
import { Loading } from '../../components/Loading';
import { DatePickerDoble } from '../../components/pickers/DatePickerDoble';
import icono from '../../../assets/images/Logobeex.fw.png'

export const Recargas = () => {
    const refTest = useRef()

    const [cargando, setCargando] = useState(false)
    const history = useHistory();

    const {
            recargas,
            listarRecargas,
            recarga,
            setRecarga,
            spinner,
            isOpenObtenerRecarga,
            closeModalObtenerRecarga,
            editarValorRecarga,
            obtenerRecarga,
            estadoBotonPintar,
            setEstadoBotonPintar,
            aceptarRecarga,
            rechazarRecarga,
            isOpenModalDenegar,
            openModalDenegar,
            closeModalDenegar,
            bancos,
            fotoRecarga,
            listarEntidadesBancarias,
            validarNroOperacion,
            nroOperacionValido,
            loading,
            medioOrigen,
            listarMedioOrigen,
            listarBancoOrigen,
            bancoOrigen


    } = useRecargas();

    const {        
        extraerTexto,
        textoConvertido,
        loadingConversion
    } = useImagenaTexto()

    const {         
        listarOperaciones,
        verificarInicioOperacion,
        operaciones,
        operacion,
        iniciarOperacion,
        finalizarOperacion,
        operacionActiva,
        resumenMontoOperaciones,
        isOpenModalResumenMonto ,
        closeModalResumenMonto,
        listarResumenMontos     
    } = useOperaciones()
    
    const {             
            chat,
            mensaje,
            mensajes,
            limpiarMensaje,
            obtenerChat,
            editarValorMensaje,
            guardarEditarMensaje,
            isOpenModalChat,
            openModalChat,
            closeModalChat,
    } = useChatOnline();

    const audioRecarga = useRef(null);
    const classNameInput2 = "p-2 caret-input text-white containerScroll h-[60px] rounded mt-[5px] px-2 w-full bg-zinc-900 text-base focus:outline-none focus:ring-1 focus:ring-blue-500"
    const classNameInput = " caret-input  text-white h-[30px] rounded px-2 w-[240px] bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center  caret-input"
    const [ startDate, setStartDate ] = useState(new Date())
    const [ endDate, setEndDate ] = useState(new Date())
    const [ recargaDate, setRecargaDate ] = useState(new Date())
    const [ verInputComentarioBloqueo, setVerInputComentarioBloqueo ] = useState(false)
    const { listarHistorialRecargas, recargaHistorial, isOpenHistorial, closeModalHistorial } = useHistorialRecargas()
    const { stateSocket } = useContext(SocketContext);
    const { stateUser, signIn } = useContext(UserContext);
    const [ isOpenChatBeex, openModalChatBeex, closeModalChatBeex ] = useModal()
    const [ isOpenModalRecarga, openModalRecarga, closeModalRecarga ] = useModal()
    const [ urlBancoElegido , setUrlBancoElegido ] = useState()
    const [ imagenBanco, setImagenBanco ] = useState("https://static.vecteezy.com/system/resources/previews/020/716/209/original/flat-icon-bank-bank-icon-where-to-keep-money-illustration-of-saving-in-the-bank-free-png.png")
    const ultimoElementoRef = useRef(null);
    const idTablaRecargas = "tablaRecargas"
    const [ isOpenModalTextoExtraido, openModalTextoExtraido, closeModalTextoExtraido ] = useModal()
    const [ rangoAtencion, setRangoAtencion ] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedValue, setSelectedValue] = useState("");
    const [ valorFiltro, setValorFiltro ] = useState("")



    useEffect(() => {
        setTimeout(() => {
            ultimoElementoRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 0);
    },[mensajes,ultimoElementoRef])

    useEffect(() => {
        listarRecargas(startDate,endDate,estadoBotonPintar);
    }, [startDate, endDate])
    
    useEffect(()=>{
        listarEntidadesBancarias()
    },[])

    useEffect(()=>{
        const usuarioSocket= {
            usuario : stateUser?.nomUsuario?.toUpperCase(),
            sesion : localStorage.getItem('sesion'),
            token: stateUser.token
        }
    },[])



    const showNotification = async (contentNotificacion) => {
        const registration = await navigator?.serviceWorker?.getRegistration()
        if( !registration ) return console.log("No hay un Service-Worker Registrado")
    
        registration.showNotification("¡Notificación!", {
            body: contentNotificacion.mensaje,
            image: icono,
            icon: icono,
            data: {
                customData: "Se esta solicitando una nueva recarga!"
            },
        })
    }

    useEffect(() => {
        console.log('stateSocket.payload ', stateSocket.payload)
        if (Object.keys(stateSocket.payload).length > 0) {
            audioRecarga?.current?.play();
            if (stateSocket.payload.message.hd.cmd == "setRecargaBiixManagerWeb"){
                notify('¡Se recibió un mensaje!', 'info', { autoClose: true });
                showNotification(stateSocket.payload.message.bd)
                listarRecargas(startDate, endDate, 52);
                if (isOpenModalChat) {
                    obtenerChat(recarga, false);
                }
            }else{
                notify('¡Se recibió una petición de Recarga!', 'info', { autoClose: true });
                showNotification(stateSocket.payload.message.bd)
                listarRecargas(startDate, endDate, 50);
            }
        }
    }, [stateSocket.payload])



    // useEffect(() => {
    //     // Notificación MQTT
    //     if (Object.keys(stateSocket.payload).length > 0) {

    //         // Reproducir sonido de recarga
    //         if (audioRecarga.current) {
    //             audioRecarga.current.play()
    //                 .catch(error => {
    //                     console.error('La reproducción del sonido falló:', error);
    //                 });
    //         }
    
    //         if (stateSocket.payload.message.hd.cmd == "setNotificacionBeexManager") {
    //             // Notificación de chat
    //             notify('¡Se recibió un nuevo mensaje!', 'info', { autoClose: true });
    //             listarRecargas(startDate, endDate, 52);
    //             if (isOpenModalChat) {
    //                 obtenerChat(recarga, false);
    //             }
    
    //             // Notificación push si el permiso está concedido
    //             if (Notification.permission == "granted") {
    //                 new Notification('¡Nuevo mensaje recibido!', {
    //                     body: 'Haz clic aquí para ver el mensaje.',
    //                     icon: '../../../assets/images/Logobeex.fw.png', // Añade un icono si lo deseas
    //                     tag: 'message-notification',
    //                 });
    //             }
    
    //         } else { // Notificación de nueva recarga
    //             listarRecargas(startDate, endDate, 50);

    //             notify('¡Se recibió una petición de Recarga!', 'info', { autoClose: true });
    
    //             // Notificación push si el permiso está concedido
    //             if (Notification.permission === "granted") {
    //                 new Notification('¡Nueva petición de recarga!', {
    //                     body: 'Haz clic aquí para ver la recarga.',
    //                     icon: '../../../assets/images/Logobeex.fw.png', // Añade un icono si lo deseas
    //                     tag: 'recarga-notification',
    //                 });
    //             }
    //         }
    //     }
    // }, [stateSocket.payload]);
    
  

    useEffect(()=>{
        verificarInicioOperacion()
        listarMedioOrigen();
        listarBancoOrigen();
    },[])

    useEffect(()=>{
    
        if(operacionActiva.isValid === true){
            notify(`Tiene operación iniciada con fecha hora ${operacionActiva.fechaHoraInicio}`,"success")
        }else{
            // notify(`No cuenta con una operación iniciada`,"error")
        }
    },[operacionActiva])

    useEffect(() => {
        setCurrentPage(1)
    },[recargas])

    const handleFocus = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
        }
    };

    const abrirChat=(chat)=>{
        chat && obtenerChat(chat)
        // closeModal()
        openModalChatBeex()
        editarValorMensaje('chatActivo', true)
        editarValorMensaje('uidDestino', chat.uid)
    }

    const enviarMensaje = async ()=>{
       await guardarEditarMensaje()
        editarValorMensaje("mensaje",'')
    }


    const [rotacion, setRotacion] = useState(0);
    const [zoom, setZoom] = useState(1);
    const toggleRotacion = () => {
      // Incrementa el estado de rotación en 90 grados con cada clic
        setRotacion((rotacion + 90) % 360);
    };
    const toggleZoom = () => {
        if (zoom === 1) {
            setZoom(1.2);
        } else if (zoom === 1.2) {
            setZoom(1.5);
        }else if (zoom ===1.5){
            setZoom(1.8);
        }else if (zoom ===1.8){
            setZoom(2.0);
        }else if (zoom ===2.0){
            setZoom(2.5);
        }else if (zoom ===2.5){
            setZoom(3.0);
        } else {
            setZoom(1);
        }
    };


    const motivosDenegacion = [
        { codMotivoDenegacion : 1 , motivo: 'No se visualiza el banco'},
        { codMotivoDenegacion : 2 , motivo: 'No se visualiza el número de operación'},
        { codMotivoDenegacion : 3 , motivo: 'Foto inválida'},
        { codMotivoDenegacion : 4 , motivo: 'Foto inapropiada'},
        { codMotivoDenegacion : 5 , motivo: 'No se visualiza el banco'},
        { codMotivoDenegacion : 6 , motivo: 'Voucher duplicado'},
    ]
    
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    
    const handleMouseDown = (e) => {
        if (e.button === 2) {
            setRotacion(0);
            setZoom(1);
            setDragOffset({ x: 0, y: 0 });
        } else {
            setIsDragging(true);
            setDragStart({ x: e.clientX, y: e.clientY });
        }
    };
    const handleDoubleClick = () => {
        setRotacion(0);
        setZoom(1);
        setDragOffset({ x: 0, y: 0 });
    };
    const handleMouseMove = (e) => {
        if (isDragging) {
            const x = e.clientX - dragStart.x + dragOffset.x;
            const y = e.clientY - dragStart.y + dragOffset.y;
            setDragOffset({ x, y });
        }
    };
    const handleMouseUp = () => {
        setIsDragging(false);
        setDragStart({ x: 0, y: 0 });
    };
    const handleSelectChange = (event) => {
        const newTextContent = event.target.options[event.target.selectedIndex].text;
        setSelectedValue(newTextContent);
        editarValorRecarga("")
        // You can do more with the selected value here if needed
    };


    const calculateTimeDifference = (dateTimeString) => {
        if (dateTimeString){
            const [datePart, timePart] = dateTimeString?.split(' ');
            const [day, month, year] = datePart?.split('/');
            const [hour, minute, second] = timePart?.split(':');
            const targetDateTime = new Date(year, month - 1, day, hour, minute, second||0);
            const currentDate = new Date();
            const differenceInMilliseconds = currentDate - targetDateTime ;
            const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));

            return differenceInMinutes;
        }
        
        return 0; 
    };

    const traspasarDatosExtraidos = ()=>{
        const banco = textoConvertido?.content.entidad_destino?.toUpperCase() 
        editarValorRecarga('codEntidadBancaria', banco == "YAPE" || banco== "BPC" ? 4 : banco == "INTERBANK"? 1 :2)
        editarValorRecarga('montoOCR', textoConvertido.content.monto)
        editarValorRecarga('fechaOCR', textoConvertido.content.fecha_hora)
        editarValorRecarga('numeroOperacionOCR', textoConvertido.content.numero_operacion)
    }
 // Solicitar permiso de notificación push cuando el componente se monte
 useEffect(() => {
    const requestNotificationPermission = async () => {
      if ('Notification' in window && navigator.serviceWorker) {
        try {
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
            // Aquí podrías agregar la lógica para registrar un service worker y suscribirte a las notificaciones push
          } else {
          }
        } catch (error) {
          console.error('Error al solicitar permisos de notificación:', error);
        }
      }
    };

    // Llamar la función para solicitar permiso
    requestNotificationPermission();
  }, []);

    const limpiarDatosExtraidos = ()=>{
        textoConvertido.content.entidad_destino = 0
        textoConvertido.content.monto= ""
        textoConvertido.content.fecha_hora = ""
        textoConvertido.content.numero_operacion = ""
    }

    {/* */}
    
    const itemsPerPage = 30;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const recargasFiltro = recargas
    ?.filter((objeto) => {
        // Object.values(objeto) devuelve un array con solo los valores: ["001", "asdad", ...]
        return Object.values(objeto).some((valor) => 
            String(valor).toLowerCase().includes(valorFiltro.toLocaleLowerCase())
        );
    })
    const recargasToDisplay = recargasFiltro
    ?.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(recargasFiltro.length / itemsPerPage);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const pageNumbers = [];
        for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    useEffect(() => {
        setCurrentPage(1)
    },[valorFiltro])

    return (
        <>
            <audio ref={audioRecarga} src={ sonidoRecarga} />

            <ContenedorParametros titulo='Recargas'>
                <DatePickerDoble
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <SearchTable setValueFilter={setValorFiltro}></SearchTable>
            </ContenedorParametros>
            {loading && <Loading nombre={'Cargando'}/>}
            { operacionActiva.isValid === false && <div className='z-50 absolute w-full h-[80%] center justify-center p-2 text-center bg-gray-500' >
                <span> No cuenta con un inicio de operaciones activo</span><br/>
                <button 
                    className="text-white bg-blue-800 w-[30%] rounded-xl lg:w-[100%] h-[50px] text-xl mt-5 center justify-center"
                    onClick={()=>history.push('/operaciones')}
                > 
                    Ir a menú de inicar operación
                </button>
            </div>}

            <BotonesEstado listarRecargas={listarRecargas} estadoActual={estadoBotonPintar} fechaInicio={startDate} fechaFin={endDate} ></BotonesEstado>
            <div className=" containerScroll mt-7 max-h-[87%] relative top-0 bottom-0 left-0 right-0 contenedor-tabla" >
                <table id={idTablaRecargas} className="table">
                    <thead>
                        <tr>
                            <th className="w-[30px]">COD</th>
                            <th className='w-[180px]' data-tip data-for={'id-toolfechac'}>FECHA C.
                                <Tooltip id={'id-toolfechac'}>Fecha de creación</Tooltip>
                            </th>
                            <th className='w-[180px]' data-tip data-for={'id-toolfechad'}>FECHA D.
                                <Tooltip id={'id-toolfechad'}>Fecha de depósito</Tooltip>
                            </th>
                            <th className='w-[250px]'>N° OPERACIÓN</th>
                            <th className='w-[250px]'>USUARIO BIIX</th>
                            <th className='w-[250px]'>CELULAR</th>
                            <th className="text-right w-[60px] ">IMPORTE</th>
                            <th>USUARIO R.</th>
                            <th>COMENTARIO</th>
                            {/* <th>ATENCIÓN</th> */}
                            {
                            estadoBotonPintar === 0 &&
                                <th className='w-[50px] '>ESTADO</th>
                            }
                            <th className="w-[80px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {  
                        
                            recargasToDisplay.length > 0 
                            ?recargasToDisplay
                            .map((r, i) => {
                                return (
                                    <tr 
                                        key={i+1} 
                                        className={` `}
                                    >
                                        <td>{r.codPeticion}</td>
                                        <td className="text-center">{r.fechaHoraCreacion}</td>
                                        <td className="text-center">{r.fechaHoraOperacion || ''}</td>
                                        <td className="text-center">{r.nroOperacion || ''}</td>
                                        <td className="text-center">{r.uid}</td>
                                        <td>{r.celular || ''}</td>
                                        <td className="text-right">S/{Number(r.montoVoucher).toFixed(2)}</td>
                                        <td className="text-center">{r.uidRecargo || ''}</td>    
                                        <td className="max-w-[100px]">
                                            {
                                                r.comentario !== null &&
                                                <>
                                                    <div data-tip data-for={'id-tooltip-' + r.codPeticion} className="w-full whitespace-nowrap overflow-hidden text-ellipsis">{r.comentario}</div>
                                                    <Tooltip id={'id-tooltip-' + r.codPeticion}>
                                                        {r.comentario}
                                                    </Tooltip>
                                                </>
                                            }
                                        </td>
                                        
                                        {
                                        estadoBotonPintar === 0 &&
                                            <td className="text-center w-[150px]"><span className={formatState(r.codEstado)}>{primeraLetraMayuscula(r.nomEstado)}</span></td>
                                        }
                                        
                                        <td className="">
                                            <button onClick={() => {obtenerRecarga(r?.codPeticion)}} className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded">
                                                <i className="fas fa-edit"></i>
                                            </button>
                                        
                                            <button 
                                                onClick={() => {obtenerChat(r);setRecarga(r)}} 
                                                className={` 
                                                    ${r.codEstado !== 52  ? 'hidden':''}
                                                    ml-2 bg-green-500 hover:bg-green-600 text-[14px] px-[5px] py-1 rounded absolute`
                                                    }
                                            >
                                                <i className="fas fa-comments"></i>
                                                { r.numMensajePendiente > 0 ?
                                                    <div className='absolute bottom-4 left-4'>
                                                        <div className='rounded-[50%] border-2 bg-blue-600 text-base  w-[17px] h-[17px]'>
                                                            <p className='text-[9px] font-bold left-1.5 bottom-[-3px]  absolute'>{r.numMensajePendiente}</p>
                                                        </div>
                                                    </div>
                                                    :''
                                                }
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                    </tbody>
                </table>
                
            </div>
            <div className="pagination ">
                <button
                    className="hover:bg-blue-500 rounded-full pagination-button px-2 "
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    >
                    <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </button>
                {
                    pageNumbers.map((page) => (
                        <button
                            key={page}
                            className={`pagination-button rounded-[100%] w-[26px] h-[26px] mx-[1px]
                                ${page === currentPage ? 
                                    ' active bg-blue-500 '
                                    :
                                    '  bg-gray-800  hover:bg-blue-500 '
                                }`
                            }
                            onClick={() => handlePageChange(page)}
                        >
                        {page}
                        </button>
                    ))
                }
                <button
                    className="hover:bg-blue-500 rounded-full pagination-button px-2  "
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    >
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </button>
            </div>

            <ModalRecarga 
                isOpen={isOpenObtenerRecarga} 
                closeModal={closeModalObtenerRecarga} 
                actionRecargar={ ()=>{aceptarRecarga(); closeModalRecarga()} } 
                actionDenegar={()=>{openModalDenegar();obtenerChat(recarga,false)}}
                title={`Gestión de Recargas [ ${recarga.uid} ]`}
                spinner={spinner}
                validButton = {{
                    account: true,
                    confirm: (recarga.codEstado === 50 || recarga.codEstado === 45 ) ? true : false , 
                    denied: (recarga.codEstado === 50 || recarga.codEstado === 45) ? true : false,
                    cancel: true
                }}
                functionalButton={{
                    account: true,
                    confirm: (recarga.codEntidadBancaria !== 0 && recarga.numeroOperacionOCR !== '' && recarga.montoOCR !== '') ? true : false,
                    denied:true,
                    cancel: true
                }}
                
            >
                {
                    isOpenObtenerRecarga &&

                    <div className=" lg:w-full lg:h-[600px]  lg:max-h-[80vh] overflow-x-hidden overflow-y-auto containerScroll">
                        <div className='w-[850px] lg:flex-col flex gap-1 items-center lg:items-start justify-center '>

                            <section className='w-[400px] '   >
                                <fieldset className='w-full relative rounded border border-gray-500 '>
                                    <legend className='text-center px-2'>
                                        <i className='fa fa-user pr-1'></i>
                                        Datos Usuario
                                    </legend>
                                    <section className='grid grid-cols-[minmax(0,30fr)_minmax(0,70fr)]
                                        gap-2 px-4 py-2  items-center'
                                    >
                                        <label className='m-0'>Nombre:</label> 
                                        <input 
                                            onChange={(e)=> editarValorRecarga('nomPersona',e.target.value)} 
                                            defaultValue={recarga.nomPersona} 
                                            className={`${classNameInput}`} 
                                            disabled
                                        />
                                        <label className=''> Usuario:</label>
                                        <input 
                                            onChange={(e)=> editarValorRecarga('nomPersona',e.target.value)} 
                                            defaultValue={recarga.uid} 
                                            className={`${classNameInput}`} 
                                            disabled
                                        />
                                        <label className=''>Celular:</label>
                                        <input  
                                            onChange={(e)=>editarValorRecarga('numCelularPrincipal',e.target.value)} 
                                            defaultValue={recarga.numCelularPrincipal} 
                                            className={`${classNameInput}`} 
                                            disabled
                                        />
                                        <label className=''>Correo:</label>
                                        <input 
                                            onChange={(e)=>editarValorRecarga('correoPrincipal',e.target.value)} 
                                            defaultValue={recarga.correoPrincipal} 
                                            className={`caret-input  text-white h-[30px] rounded px-2 w-[240px]
                                            bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500
                                            text-center  caret-input`}
                                            disabled
                                        />
                                        <button 
                                            onClick={() => listarHistorialRecargas(recarga.uid)}
                                            className='col-span-2 ml-[30%] w-[150px] py-[2px] bg-green-500 hover:bg-green-700 text-xl rounded' >
                                            <i data-tip data-for='toolHistorial' className="text-[17px] fa fa-list m-1" />
                                            <span className='text-[15px]'>
                                                Mostrar Historial
                                            </span>
                                            <Tooltip id='toolHistorial'>Mostrar Historial</Tooltip>
                                        </button>
                                    </section>
                                </fieldset>

                                <fieldset className=" w-full relative form-content rounded border border-gray-500">
                                    <legend className='text-center px-2'>
                                        <i className='fa fa-mobile pr-1'></i>
                                        Detalle Recarga
                                    </legend>
                                    <section className='grid grid-cols-[minmax(0,30fr)_minmax(0,70fr)]
                                        gap-2 px-4 py-2 items-center'
                                    >
                                        <label className='mr-1'>Fecha Op.:</label>
                                        <DatePickerABX 
                                            date={recarga.fechaOCR}
                                            setDate={editarValorRecarga}
                                            classNameInput={'lg:w-[350px] w-full text-md lg:text-xs bg-zinc-900'}
                                            keyDate='fechaOCR'
                                        />
                                        <label className='mr-1'>Banco:</label>
                                        <div className='flex gap-1'>
                                            <select
                                                className={` caret-input lg:w-[90%] lg:mr-0 text-white
                                                    h-[30px] rounded px-2 w-[190px] bg-zinc-900 focus:outline-none
                                                    focus:ring-1 focus:ring-blue-500 text-sm caret-input containerScroll`} 
                                                onChange={(e) => {
                                                    const valorSeleccionado = Number(e.target.value);
                                                    editarValorRecarga('codEntidadBancariaCuenta', valorSeleccionado);
                                                
                                                    const bancoSeleccionado = bancos.find(
                                                        (banco) => banco.codEntidadBancariaCuenta == valorSeleccionado
                                                    );                                            
                                                    if (bancoSeleccionado) {
                                                        setUrlBancoElegido(bancoSeleccionado.urlPaginaOficialEntidadBancaria);
                                                        setImagenBanco(bancoSeleccionado.urlLogoEntidadBancaria);
                                                    }else{
                                                        setUrlBancoElegido("");
                                                        setImagenBanco("https://static.vecteezy.com/system/resources/previews/020/716/209/original/flat-icon-bank-bank-icon-where-to-keep-money-illustration-of-saving-in-the-bank-free-png.png");
                                                    }
                                                }}
                                                defaultValue={recarga.codEntidadBancariaCuenta}
                                            >
                                                <option value={0}>-- Seleccione un Banco --</option>
                                                {
                                                    bancos?.map((banco,i) => {
                                                        return <option className='px-5 ' key={i+1} value={banco.codEntidadBancariaCuenta}>{banco.abrevEntidadBancaria} | {banco.nroCuentaBancaria} | {banco.cci} </option>
                                                    })
                                                }   
                                            </select>
                                            <button 
                                                target='_blank'
                                                data-tip 
                                                data-for='toolRedirigirBanco'
                                                className={`absolute lg:hidden right-0 text-white h-[25px] rounded mr-[15px] w-[40px] h-[30px] bg-white hover:bg-white-700` }
                                                onClick={urlBancoElegido? ()=> window.open(urlBancoElegido, '_blank') : ()=> notify("Seleccione un banco", "error") }
                                            >
                                                <img src={imagenBanco} className='w-full h-full border border-gray-400 rounded' alt='Logo del banco'></img>
                                            </button>

                                        </div>
                                        <label className='mr-1'>N° Op.:</label>
                                        <div className='flex gap-1'>
                                            <input 
                                                onChange={(e)=>{editarValorRecarga('numeroOperacionOCR',e.target.value)}} 
                                                defaultValue={recarga.numeroOperacionOCR} 
                                                className={`caret-input w-full lg:mr-0  text-white h-[30px] rounded px-2
                                                    bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500
                                                    text-center  caret-input 
                                                `}
                                            />
                                            <button 
                                                data-tip 
                                                data-for={ "toolTipNumOperacion"}
                                                className={` ${nroOperacionValido.isValid? 'hidden fa fa-check' : 'fa fa-times' }
                                                    ${nroOperacionValido.isValid? ' text-green-400 hover:text-green-500' : 'text-red-500 hover:text-red-500' }
                                                    absolute right-0  rounded mr-[15px] px-3 w-[40px] h-[30px]  ` }
                                                onClick={
                                                    nroOperacionValido? () => {
                                                        validarNroOperacion();
                                                        notify(
                                                            nroOperacionValido.isValid? 
                                                                nroOperacionValido.content 
                                                                :
                                                                nroOperacionValido?.exceptions[0].description,
                                                                nroOperacionValido.isValid?
                                                                    "success"
                                                                    :
                                                                    "error"
                                                            ) 
                                                        }
                                                        :
                                                        ()=> notify("Debe ingresar un número de operación válido","error")
                                                }

                                                
                                            >
                                            </button>
                                            <Tooltip id={'toolTipNumOperacion'}>
                                                {`${nroOperacionValido.isValid? ' ' : 'Ya se encuentra registrado en el sistema'}`}
                                            </Tooltip>
                                        </div>
                                        <label className=''>Monto:</label>                                    
                                        <input
                                            onChange={(e) => editarValorRecarga('montoOCR',e.target.value )} 
                                            value={recarga.montoOCR} 
                                            className={`w-full lg:mr-0 caret-input text-white
                                                rounded  bg-zinc-900 text-[25px] focus:outline-none
                                                focus:ring-1 focus:ring-blue-500 h-[35px]
                                                text-center caret-input 
                                            `}
                                            onKeyPress={(e) => soloDecimal(e, e.target)}
                                            onFocus={(e) => e.target.select()}
                                            onBlur={(e) => editarValorRecarga('montoOCR', e.target.value)}
                                        />
                                        <label className=''> Comentario:</label>
                                        <input 
                                            onChange={(e)=>editarValorRecarga('comentario',e.target.value)} 
                                            defaultValue={recarga.comentario} 
                                            className={`caret-input w-full lg:mr-0 text-white h-[30px] rounded
                                                px-2 bg-zinc-900 focus:outline-none focus:ring-1
                                                focus:ring-blue-500 text-center  caret-input
                                            `}
                                        />
                                        <label className=''>Medio recarga:</label>
                                        <select
                                            className={`caret-input lg:w-[90%] lg:mr-0 text-white
                                                h-[30px] rounded px-2 w-full bg-zinc-900 focus:outline-none
                                                focus:ring-1 focus:ring-blue-500   caret-input containerScroll
                                            `}
                                            value={recarga.codRecargaTipo}
                                            onChange={(e) => editarValorRecarga('codRecargaTipo', Number(e.target.value))}
                                        >
                                            <option key={'opcion_0_medio'} value={0}>--Seleccione--</option>
                                            {
                                                medioOrigen.map((medio) => (
                                                    <option key={'tipo-' + medio.codRecargaTipo} value={medio.codRecargaTipo}>{medio.nomRecargaTipo}</option>
                                                ))
                                            }
                                        </select>
                                        <label className='m-0'>Banco origen:</label>
                                        <select
                                            className={`caret-input lg:w-[90%] lg:mr-0 text-white h-[30px] rounded
                                                px-2 w-full bg-zinc-900 focus:outline-none focus:ring-1
                                                focus:ring-blue-500   caret-input containerScroll
                                            `}
                                            value={recarga.codEntidadBancariaOrigen}
                                            onChange={(e) => editarValorRecarga('codEntidadBancariaOrigen', Number(e.target.value))}
                                        >
                                            <option key={'opcion_0'} value={0}>--Seleccione--</option>
                                            {
                                                bancoOrigen.map((banco) => (
                                                    <option key={'banco-' + banco.codEntidadBancaria} value={banco.codEntidadBancaria}>{banco.nomEntidadBancaria}</option>
                                                ))
                                            }
                                        </select>
                                        <label className='m-0'>Codigo seguridad:</label>
                                        <input
                                            className={`caret-input w-full lg:mr-0 text-white h-[30px] rounded
                                                px-2 bg-zinc-900 focus:outline-none focus:ring-1
                                                focus:ring-blue-500 text-center  caret-input
                                            `}
                                            maxLength={3}
                                            value={recarga.codSeguridad}
                                            onChange={(e) => editarValorRecarga('codSeguridad', e.target.value)}
                                        />
                                    </section>
                                </fieldset>
                            </section>

                            <div className='z-0 rounded w-[400px] h-[535px] relative mt-1 lg:w-[300px]  lg:h-auto containerScroll overflow-y-auto overflow-x-auto flex justify-center items-center'>
                                
                                <div className= {` ${loadingConversion? '  ': 'hidden'} mt-[70px] ml-[30px] absolute`}>
                                    <div className="absolute z-113212110 loadingT text-[25px]">Extrayendo texto...
                                        <div className="spinner-sec spin-sec-oneT"></div>
                                        <div className="spinner-sec spin-sec-twoT"></div>
                                        <div className="spinner-sec spin-sec-threeT"></div>
                                    </div>
                                </div>

                                <img 
                                    src={fotoRecarga} alt='Foto de la recarga'                                    
                                    className={` rounded h-[100%] lg:h-auto`}
                                
                                />

                                <button 
                                    data-tip 
                                    data-for='toolRedireccionarFoto' 
                                    className='absolute right-0 bottom-0 bg-blue-500 hover:bg-blue-700 text-xl rounded' 
                                    style={{zIndex:'100000'}}
                                >
                                    <a  
                                        className="m-1 fa fa-share" 
                                        target="_blank" 
                                        href={`${fotoRecarga}`} 
                                        rel="noopener noreferrer" 
                                    >
                                    </a>
                                    <Tooltip id='toolRedireccionarFoto' >Abrir Foto</Tooltip>
                                </button>

                                <button 
                                    className='absolute right-0 bottom-[90px] w-[28px] bg-green-800 hover:bg-green-700 text-xl rounded' 
                                    // className={`flex rounded h-full w-full transform rotate-${rotacion}`}

                                    style={{zIndex:'100000'}}
                                    onClick={toggleZoom}
                                >
                                    <i 
                                        data-tip 
                                        data-for='toolZoomFoto' 
                                        className="fa fa-search-plus" 
                                    />

                                    <Tooltip
                                        id='toolZoomFoto' 
                                    >Zoom x{zoom}
                                    </Tooltip>
                                </button>

                                <button 
                                    className='absolute right-0 bottom-[60px] w-[28px] bg-green-800 hover:bg-green-700 text-xl rounded' 
                                    // className={`flex rounded h-full w-full transform rotate-${rotacion}`}

                                    style={{zIndex:'100000'}}
                                    onClick={toggleRotacion}
                                >
                                    <i 
                                        data-tip 
                                        data-for='toolGirarFoto' 
                                        className="fa fa-retweet" 
                                    />
                                    <Tooltip
                                        id='toolGirarFoto' 
                                    >Girar
                                    </Tooltip>
                                </button>

                                <button 
                                    onClick={()=>{extraerTexto(fotoRecarga);openModalTextoExtraido()} }
                                    // onClick={()=>extraerTexto(fotoRecarga)} 
                                    className='absolute right-0 bottom-[30px] w-[28px] bg-green-500 hover:bg-green-700 text-xl rounded' 
                                    style={{zIndex:'100000'}}>
                                    <i 
                                        data-tip 
                                        data-for='toolExtraerTexto'
                                        className="fa fa-eye"
                                    />

                                    <Tooltip id='toolExtraerTexto'>Extraer Texto</Tooltip>

                                    <Tooltip id='toolRedirigirBanco'>Abrir Banca por Internet </Tooltip>

                                </button>

                                {/* rotate-90 scale-150 */}
                                
                            </div>
                        </div>

                    </div>

                }
            </ModalRecarga>

            <Modal  // MODAL DE DENEGAR
                isOpen={isOpenModalDenegar} 
                closeModal={closeModalDenegar} 
                action={()=>{rechazarRecarga()}}
                title= {"Denegar recarga"}
                spinner={spinner}
                textButtons={{ confirm: 'Denegar', denied:'Cancelar' }}
                validButton ={{ confirm: true, denied: true }} 
            >
                <>
                    <div className="flex gap-8 items-center flex-wrap justify-center lg:flex-col lg:gap-0">
                        <div className="w-[600px] px-4 lg:w-full lg:px-0">
                            <span className="text-center">Motivo denegación (Se enviará al usuario):</span>
                            <br/>
                                <select
                                    className={` caret-input  text-white mr-[50px] h-[30px] rounded px-2 w-full bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500   caret-input containerScroll`} 
                                    onChange={(e) => {
                                        const valorSeleccionado = e.target.value;
                                        const motivoSeleccionado = motivosDenegacion.find(
                                            (md) => md.codMotivoDenegacion == valorSeleccionado
                                        );
                                        editarValorRecarga("comentarioDenegar",motivoSeleccionado.motivo)
                                    }}
                                    defaultValue={0}
                                >
                                    <option value={0}>-- Seleccione un motivo --</option>
                                    {
                                        motivosDenegacion?.map((md,i) => {
                                            return <option className='px-5 ' key={i+1} value={md.codMotivoDenegacion}>{md.motivo}</option>
                                        })
                                    }   
                                </select>
                            
                            <textarea 
                                autoFocus={true} 
                                onChange={(e) =>{
                                    editarValorRecarga('comentarioDenegar', e.target.value);
                                    editarValorRecarga('mensaje', e.target.value);
                                    }} 
                                className={`${classNameInput2} `}
                                value={recarga.comentarioDenegar}
                            > </textarea>
                            
                            <div className='relative mt-[8px] text-right max-w-full'> 
                                <label className='mr-[10px] '>Habilitar Conversación</label>
                                <label className="switch top-1">
                                    <input
                                        className='' 
                                        type="checkbox" 
                                        onChange={(e)=> {
                                            editarValorMensaje('chatActivo', e.target.checked? true : false)
                                            editarValorRecarga('chatActivo', e.target.checked ? true : false)
                                        }}
                                    />
                                    <div className="slider"></div>
                                </label>
                            </div>
                            
                            <div className='relative mt-[8px] text-right max-w-full'> 
                                <label className='mr-[10px]'>Amonestar Usuario</label>  
                                <label className="switch top-1"> 
                                    <input 
                                        className='' 
                                        type="checkbox" 
                                        onChange={(e)=> {
                                            const checkeado = e.target.checked? true : false  
                                            editarValorRecarga('amonestaUsuario', checkeado)
                                            setVerInputComentarioBloqueo(checkeado || recarga.sugiereBloqueo); 
                                            !(checkeado || recarga.sugiereBloqueo) && editarValorRecarga("motivoAmonestacionBloqueo","") 
                                        }
                                        }
                                    />
                                    <div className="slider"></div>
                                </label>
                            </div>
                                
                            <div className='relative mt-[8px] text-right max-w-full'> 
                                <label className='mr-[10px]'>Sugerir Bloqueo</label>
                                <label className="switch top-1">
                                    <input 
                                        className='' 
                                        type="checkbox" 
                                        onChange={(e)=> {
                                                const checkeado = e.target.checked? true : false  
                                                editarValorRecarga('sugiereBloqueo',checkeado)
                                                setVerInputComentarioBloqueo(checkeado || recarga.amonestaUsuario); 
                                                !(checkeado || recarga.amonestaUsuario) && editarValorRecarga("motivoAmonestacionBloqueo","") 
                                            }
                                        }
                                    />
                                    <div className="slider"></div>
                                </label>
                            </div>

                            <div className={`w-[600px] px-4 lg:px-0 lg:w-full `}>
                                <label className="text-center">Comentario de amonestación y/o bloqueo:</label>
                                <textarea 
                                    onChange={(e) =>{editarValorRecarga('motivoAmonestacionBloqueo', e.target.value)}} 
                                    className={`${classNameInput2} ${verInputComentarioBloqueo? '  bg-zinc-900 ' : ' bg-zinc-700 ' }`}
                                    disabled = {!verInputComentarioBloqueo}
                                    defaultValue={recarga.motivoAmonestacionBloqueo}
                                    autoFocus={true}
                                > 
                                </textarea>
                            </div>

                        </div>

                    </div>
                </>                
            </Modal> 
        
            <Modal   //HISTORIAL DE LAS ULTIMAS 10 RECARGAS
                isOpen={isOpenHistorial} 
                closeModal={closeModalHistorial} 
                action={closeModalHistorial}
                title= {"Historial 10 Ultimas Recargas"}
                spinner={spinner}
                textButtons={{ confirm: 'Cerrar', denied:'Cancelar'}}
                validButton ={{confirm: true, denied: false}} 
            >
                <div className=" containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                    <table className="table">
                        <thead>
                            <tr>    
                                <th className="w-[30px]">N</th>
                                <th>COD</th>
                                <th>FECHA C.</th>
                                <th>FECHA D.</th>
                                <th>N° OP.</th>
                                <th>IMPORTE</th>
                                <th>USUARIO R.</th>
                                <th>COMENTARIO</th>
                                <th>ESTADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {   
                                recargaHistorial.length > 0 
                                ? recargaHistorial.map((h, i) => {
                                    const fechaRecarga = h.fechaHoraCreacion.split('T')[0] + ' ' + h.fechaHoraCreacion.split('T')[1].split('.')[0]
                                    return (
                                        <tr key={i+1}>
                                            <td>{++i}</td>
                                            <td>{h.codPeticion}</td>
                                            <td className="text-center">{fechaRecarga}</td>
                                            <td className="text-center">{h.fechaDeposito || ''}</td>
                                            <td className="text-center">
                                                {h.codPeticionDuplicado ?
                                                    <>
                                                        <i data-tip data-for={'id-tooltip-' + h.codPeticion} className='fa fa-circle text-red-500 pr-2'></i>
                                                        <Tooltip id={'id-tooltip-' + h.codPeticion}>
                                                            {h.codPeticionDuplicado}
                                                        </Tooltip>
                                                    </> 
                                                    : ''
                                                } {h.nroOperacion || ''}
                                            </td>
                                            <td className="text-right">{h.montoVoucher}</td>
                                            <td className="text-center">{h.uidRecargo || ''}</td>
                                            <td className="text-center">{h.comentario}</td>
                                            <td className="text-center"><span className={formatState(h.codEstado)}>{h.nomEstado}</span></td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>

            </Modal>
            
            <Modal 
                isOpen={isOpenModalChat} closeModal={() => {closeModalChat();limpiarMensaje()}} action={{}}
                title= {`CHAT ONLINE [${chat.codPeticion}] - ${chat.uid}`} 
                spinner={spinner}
                textButtons={{  denied:'cerrar'}}
                validButton ={{ denied: true}}
            >
                <>
                    <div className='h-[450px] '>
                        <ol className="chat  containerScroll rounded h-[400px] w-[420px]">
                            {   
                                mensajes.length > 0 
                                ? mensajes.map((m, i) => {
                                    return (
                                        <li 
                                            ref={i === mensajes.length - 1 ? ultimoElementoRef : null}
                                            key={i+1} 
                                            className={`${m.codAccesoTipo == 1? 'other' : 'self'}`} 
                                        >
                                            <div className="avatar">
                                                <img 
                                                    src={m.codAccesoTipo == 1? fotoChat : fotobeexserver} 
                                                    className='w-[50px]' 
                                                    alt=""
                                                /> 
                                            </div>
                                            <div className="msg">
                                                <p style={{wordBreak:'break-word'}}>{m.mensaje}</p>
                                                <time>{m.fechaHoraCreacion}</time>
                                            </div>
                                        </li>
                                    )
                                })
                                : <div colSpan="10" className="text-center w-[100px]">No hay Chat.</div>
                            }
                        </ol>


                        <div className='mt-5 border-t  flex items-center'>
                            <textarea 
                                id='txtComentario' 
                                autoFocus={true} 
                                value={mensaje.mensaje} 
                                placeholder="escriba aqui..." 
                                className={`text-white h-[50px] rounded mt-[10px] px-4 w-[350px] bg-zinc-900 text-base focus:outline-none focus:ring-1 focus:ring-blue-500 caret-input  `} 
                                onChange={(e) =>{
                                    editarValorRecarga('comentarioDenegar', e.target.value);
                                    editarValorMensaje('mensaje', e.target.value);
                                }}
                            ></textarea> 
                            <button
                                className='bg-green-500 p-3 h-12 mt-2 rounded  ml-2'
                                onClick={async () => {
                                    await enviarMensaje()
                                    listarRecargas(startDate,endDate,estadoBotonPintar)
                                }}
                            >  Enviar </button>
                        </div>

                        <div className='relative p-5 text-left w-[70%]'> 
                            <label className='mr-[10px]'>Habilitar Conversación</label>
                            <label className="switch top-1">
                                <input 
                                    className='' 
                                    type="checkbox" 
                                    checked={mensaje.chatActivo || false} 
                                    onChange={(e)=>{
                                        editarValorMensaje('chatActivo', e.target.checked? true : false);
                                    }}
                                />
                                
                                <div className="slider"></div>
                            </label>
                        </div>
                    </div>
                </>                
            </Modal>

            <Modal
                isOpen={isOpenModalTextoExtraido} closeModal={()=>{closeModalTextoExtraido();limpiarDatosExtraidos()}} action={()=>{traspasarDatosExtraidos();closeModalTextoExtraido();limpiarDatosExtraidos()}}
                title= {`Texto extraído`} 
                spinner={spinner}

                textButtons={{ confirm: 'Traspasar datos', denied:'Cancelar'}}
                validButton ={{confirm: true, denied: true}} 
            >
            
                <div className='flex text-l flex-col justify-between w-[250px]'>
                    <div className=' flex justify-between'>
                        <div className='flex'>
                            Fecha:
                        </div>
                             
                        <div className='flex'>
                            <input className='chbTE' type="checkbox" id="box-1"/>
                            <label className='lblTE' htmlFor="box-1">{textoConvertido?.content?.fecha_hora || '02/12/2023 12:33'}</label>
                        </div>
                    </div>
                    
                    <div className='flex  justify-between'>
                        <div className='flex'>
                            Banco:
                        </div>
                        <div className='flex'>
                            <input className='chbTE' type="checkbox" id="box-2"/>
                            <label className='lblTE' htmlFor="box-2">{textoConvertido?.content?.entidad_destino}</label>
                        </div>
                    </div>

                    <div className='flex justify-between'>
                        <div className='flex'>
                            N° Operación:
                        </div>
                        <div className='flex  '>
                            <input className='chbTE' type="checkbox" id="box-3"/>
                            <label className='lblTE' htmlFor="box-3">{textoConvertido?.content?.numero_operacion}</label>
                        </div>
                    </div>


                    <div className='flex justify-between'>

                        <div className='flex'>
                            Monto: 
                        </div>
                        <div className='flex'>
                            <input className='chbTE' type="checkbox" id="box-4"/>
                            <label className='lblTE' htmlFor="box-4">S/ {textoConvertido?.content?.monto}</label>
                        </div>
                    </div>

                </div>
                    



            </Modal>
        </>
    )
}
